import { useEffect, useState } from "react";

function computeParts(target) {
  const now = Date.now();
  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s, ended: diff === 0 };
}

export default function Countdown({ targetIso }) {
  const target = new Date(targetIso).getTime();
  const [t, setT] = useState(() => computeParts(target));

  useEffect(() => {
    const id = setInterval(() => setT(computeParts(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const cell = (val, label, tid) => (
    <div className="flex flex-col items-center px-2 sm:px-6 py-3 sm:py-4 rounded-2xl gold-border min-w-[64px] sm:min-w-[76px]" data-testid={tid}>
      <div className="font-mono font-bold text-2xl sm:text-5xl gold-text tabular-nums">
        {String(val).padStart(2, "0")}
      </div>
      <div className="text-[9px] sm:text-xs mt-1 tracking-[0.2em] sm:tracking-[0.3em] uppercase text-muted-foreground">{label}</div>
    </div>
  );

  return (
    <div className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap" data-testid="countdown">
      {cell(t.d, "Dias", "cd-days")}
      {cell(t.h, "Horas", "cd-hours")}
      {cell(t.m, "Min", "cd-minutes")}
      {cell(t.s, "Seg", "cd-seconds")}
    </div>
  );
}
